import { getEmployeeCommuteTemplate } from "@/api/template";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import FileUploader from "@/components/FileUploader/FileUploader";
import PageButtonGroup from "@/components/PageButtonGroup/PageButtonGroup";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import useTranslation from "@/hooks/useTranslation";
import CommuteTable from "@/pages/employee/commute/CommuteTable";
import { EMPLOYEE_COMMUTE_UPLOAD_COLUMNS } from "@/pages/employee/commute/constants";
import { DownloadOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";

function EmployeeCommute() {
  const translation = useTranslation();

  return (
    <div>
      <PageHeader
        title={translation.employee.commute.overview.pageTitle}
        description={translation.employee.commute.overview.pageDescription}
        right={
          <PageButtonGroup>
            <FileUploader
              uploadType={"employee_commute"}
              uploadDataTableProps={{
                columns: EMPLOYEE_COMMUTE_UPLOAD_COLUMNS,
                rowKey: "id",
              }}
              templateUrlFn={getEmployeeCommuteTemplate}
            />
            <FileDownloader
              tooltipText="Download template"
              fileOutputName={`template-employee-commute.xlsx`}
              fileUrlFn={getEmployeeCommuteTemplate}
              buttonText={"Template"}
              icon={<DownloadOutlined />}
            />
          </PageButtonGroup>
        }
      />
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <CommuteTable />
        </Col>
      </Row>
    </div>
  );
}

export default EmployeeCommute;
